import React from "react";
import AnalyticsDashboard from "../../components/Analytics/AnalyticsDashboard";

const AnalyticsPage = () => <AnalyticsDashboard />;

export default AnalyticsPage;
